import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './TollFreeOrigination.css';

const TollFreeOrigination = () => {
  return (
    <div className="tollfree-container">
      <div className="tollfree-hero">
        <motion.div 
          className="tollfree-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="tollfree-hero-title">Toll-Free / 8YY Origination</h1>
          <h2 className="tollfree-hero-subtitle">
            Elevate Your Connectivity with DirectRoutes Networks' Toll-Free / 8YY Origination Services
          </h2>
          <Link to="/contact" className="tollfree-cta-btn">
            <motion.button
              className="tollfree-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </div>

      <div className="tollfree-content">
        <div className="tollfree-intro-section">
          <p className="tollfree-intro">
            Welcome to DirectRoutes Networks' Toll-Free / 8YY Origination Service, where connectivity is effortless, efficient, and cost-effective. We understand the critical role seamless communication plays in your business operations. Our service is designed to deliver reliable, high-quality inbound calls across the United States and Canada, ensuring your customers can always reach you—without incurring any cost.
          </p>
        </div>

        <div className="tollfree-text-section">
          <h2 className="tollfree-section-title">Toll-Free / 8YY Number Portability Made Easy</h2>
          <p className="tollfree-section-text">
            Port your toll-free number to DirectRoutes Networks and experience smooth, uninterrupted connectivity. Our streamlined porting process ensures a quick, hassle-free transition to our robust network. Choose from a wide selection of toll-free numbers across the U.S. and Canada to find the one that best suits your business needs.
          </p>
        </div>

        <div className="tollfree-text-section">
          <h2 className="tollfree-section-title">Nationwide Toll-Free Reach</h2>
          <p className="tollfree-section-text">
            Easily transfer your existing toll-free number to DirectRoutes Networks while maintaining uninterrupted service. Our end-to-end porting process ensures a seamless transition to our reliable network, without delays or complications. With our extensive range of toll-free numbers throughout the U.S. and Canada, you gain the flexibility to align your communication strategy with your business objectives while maintaining the high-quality service your customers expect.
          </p>
        </div>

        <div className="tollfree-text-section">
          <h2 className="tollfree-section-title">Unmatched Reliability with a Fully Redundant Network</h2>
          <p className="tollfree-section-text">
            Reliability and uptime are critical for any toll-free solution, and DirectRoutes Networks delivers on both. Our cost-effective, redundant, and resilient Toll-Free / 8YY Origination service ensures your business remains connected at all times. By leveraging multiple toll-free networks across North America, we provide continuous, high-quality service. In the rare event of a disruption, our dedicated 24/7 Network Operations Center responds immediately to restore full functionality, minimizing downtime and protecting your customer experience.
          </p>
        </div>

        <div className="tollfree-cta">
          <p className="tollfree-cta-text">
            Partner with DirectRoutes Networks to strengthen your communication infrastructure and elevate your toll-free connectivity to the next level.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TollFreeOrigination;
